<template>
  <main class="report-enterprise-page">
    <header class="report-enterprise-hero">
      <div class="report-enterprise-hero__content">
        <span class="report-enterprise-hero__icon"><i :class="icon"></i></span>
        <div>
          <span class="report-enterprise-eyebrow">{{ eyebrow }}</span>
          <h1>{{ title }}</h1>
          <p>{{ description }}</p>
        </div>
      </div>
      <div class="report-enterprise-hero__status">
        <i class="fas fa-sync-alt"></i>
        Data operasional
      </div>
    </header>

    <section class="report-enterprise-panel">
      <div class="report-enterprise-panel__heading">
        <div>
          <span class="report-enterprise-eyebrow">Analisis laporan</span>
          <h2>Filter dan data laporan</h2>
          <p>Pilih periode dan parameter yang dibutuhkan untuk menampilkan data.</p>
        </div>
        <span class="report-enterprise-panel__icon"><i class="fas fa-filter"></i></span>
      </div>
      <div class="report-enterprise-content">
        <slot />
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "ReportPageShell",
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    icon: { type: String, default: "fas fa-chart-line" },
    eyebrow: { type: String, default: "Business intelligence" },
  },
};
</script>

<style lang="scss" src="@/assets/sass/pages/_report-enterprise.scss"></style>
